import { Stack, FlexboxGrid, Col } from 'rsuite';
import classNames from 'classnames';
import MenuIcon from '@rsuite/icons/Menu';
import { HomeElms, server } from '../config/const';
import { useAppSelector, useAppDispatch } from '@monorepo/shared';
import {
  Brand,
  OUTree,
  NoticeSpeaker,
  UserProfile,
  ServiceDropdown,
  SupportDropdown
} from '@monorepo/shared/components';
import ServiceImg from '../images/header/service.svg';
import supportImg from '../images/header/support.svg';
import { cloudLog } from '../pages/Home/homeCons';
import { useGetCommonDataQuery } from '@monorepo/shared/services/globalApi';
import {
  isExpanded,
  updateExpanded
} from '@monorepo/shared/store/sidemenuSlice';
import { useLocation } from 'react-router-dom';
import { CSSProperties } from 'react';
import {
  selectNotices,
  selectPermission
} from '@monorepo/shared/store/authSlice';
import {
  selectCurrentAccount,
  selectLoginAccount,
  selectLoginSaml
} from '@monorepo/shared/store/accountSlice';
import { selectOU } from '@monorepo/shared/store/fcOuSlice';
interface IProps {
  hideSideMenu?: boolean;
  style?: CSSProperties;
}

const Header = ({ hideSideMenu, style }: IProps) => {
  const userPermission = useAppSelector(selectPermission);
  const { pathname } = useLocation();
  const loginSaml = useAppSelector(selectLoginSaml);
  const ouData = useAppSelector(selectOU);
  const notices = useAppSelector(selectNotices);
  const currentAccount = useAppSelector(selectCurrentAccount);
  const commonData = useGetCommonDataQuery({ server: server });
  const menuExpanded = useAppSelector(isExpanded);
  const logoIcon = (
    <img
      src={cloudLog}
      width="46px"
      style={{ filter: 'invert(1)', marginRight: '8px' }}
    ></img>
  );
  const logoClasses = classNames('left-container', {
    expand: menuExpanded
  });
  const dispatch = useAppDispatch();

  return (
    <FlexboxGrid className="frame-header" justify="space-between" style={style}>
      <FlexboxGrid.Item className={logoClasses}>
        <Stack alignItems="center" style={{ height: '100%' }} spacing={30}>
          {!hideSideMenu && (
            <MenuIcon
              onClick={() => dispatch(updateExpanded(!menuExpanded))}
              style={{ cursor: 'pointer' }}
            />
          )}
          <Brand
            // link={`/organization`}
            logo={logoIcon}
            title={HomeElms.name}
            subtitle={'Cloud'}
            titleStyle={{
              fontWight: 'blod',
              fontSize: '1.2rem',
              color: '#212121'
            }}
            subTitleStyle={{
              fontWight: 'blod',
              fontSize: '1.2rem',
              paddingLeft: '8px',
              color: '#212121'
            }}
          />
          {currentAccount?.portals?.some(
            (item: Record<string, any>) => item?.visibility !== 'Hide'
          ) && (
            <ServiceDropdown
              commonData={commonData?.data}
              account={currentAccount}
            />
          )}
          {currentAccount?.support_menu?.some(
            (item: Record<string, any>) => item?.visibility !== 'Hide'
          ) && (
            <SupportDropdown
              commonData={commonData?.data}
              account={currentAccount}
            />
          )}
        </Stack>
      </FlexboxGrid.Item>
      <FlexboxGrid.Item
        as={Col}
        md={4}
        ms={4}
        xs={4}
        className="right-container"
      >
        <Stack
          spacing={20}
          justifyContent="flex-end"
          style={{ height: '100%' }}
        >
          <NoticeSpeaker notices={notices} />
          {!pathname.includes('cred') && ouData?.length ? <OUTree /> : <></>}
          <UserProfile
            account={currentAccount}
            loginSaml={loginSaml}
            commonData={commonData?.data}
          />
        </Stack>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default Header;
